<form [formGroup]="form" *ngIf="entity">
  <br />
  <!-- Added by amisha for MapSketch Data Entity Input component on 02-01-2026 -->
  @if (!templateForPermitForm) {
  <wm-de-label [entity]="entity" [for]="entity.templateCode"> </wm-de-label>

  } @else {
  <wm-common-text
    class="permit-label"
    [data]="{
      text: entity.label,
    }"
  >
  </wm-common-text>
  }
  <!-- End of addition by amisha for MapSketch Data Entity Input component on 02-01-2026  -->
  <app-esri-map
    *ngIf="mapsketchDataEntity.mapConfig.mapServiceId"
    #mapComp
    [mapServiceId]="mapsketchDataEntity.mapConfig.mapServiceId"
    [basemapName]="mapsketchDataEntity.mapConfig.basemapName"
    [initialExtent]="mapsketchDataEntity.mapConfig.initialExtent"
    [mapLayerOptions]="mapsketchDataEntity.mapConfig.layers"
    [showToc]="mapsketchDataEntity.mapConfig.showToc"
    [useSketchLayer]="true"
    (mapSketchDataChanged)="onMapSketchDataChange($event)"
    (mapLoaded)="onMapLoaded($event)"
    (mapExtentChanged)="onMapExtentChanged($event)"
    (mapChanging)="onMapChanging($event)"
    [mapDimensionLayout_class]="mapDimensionLayout_class"
    toolbarMode="sketch"
    [startingZoomLevel]="mapsketchDataEntity.mapConfig.initialZoom"
    [popupActions]="mapPopupActions"
    (graphicStateChanged)="updateUnsubmittedGraphic()"
  ></app-esri-map>
  <p
    *ngIf="
      graphicsRequiredControl &&
      graphicsRequiredControl.touched &&
      graphicsRequiredControl.invalid
    "
    class="text-red mt-3 font-weight-bold"
  >
    You are required to draw a sketch on the map.
  </p>
  <p
    *ngIf="
      form.controls['map_loading'].invalid &&
      form.controls['map_loading'].touched
    "
    class="text-red mt-3 font-weight-bold"
  >
    Please wait while the map loads.
  </p>

  <wm-control-message
    *ngIf="form && form.controls[saveValidationGroupKey]"
    [control]="
      form.controls[saveValidationGroupKey].controls['unsubmittedGraphic']
    "
  ></wm-control-message>
</form>
